// blockscripts.js
// 🧠 User intent triggers
/* const userIntentEvents = [
  "mousemove",
  "mousedown",
  "scroll",
  "keydown",
  "touchstart"
];

function unblockAllScripts() {
  if (window.unblockedScripts?.unblocked) return;

  window.unblockedScripts = { unblocked: true };

  if (window.yett && typeof window.yett.unblock === 'function') {
    console.log("▶️ Unblocking scripts");
    window.yett.unblock();
    window.yettLoaded = true;
  } else {
    console.warn("⚠️ Yett not available at unblock time");
  }

  // Save state for this session
  try {
    sessionStorage.setItem("scripts-unblocked", JSON.stringify({ unblocked: true }));
  } catch (e) {
    console.warn("SessionStorage not available", e);
  }

  // Remove listeners to avoid memory leaks
  userIntentEvents.forEach(event =>
    window.removeEventListener(event, unblockAllScripts, true)
  );
}

// Check if previously unblocked
try {
  const previouslyUnblocked = JSON.parse(
    sessionStorage.getItem("scripts-unblocked") || "{}"
  );
  
  if (previouslyUnblocked.unblocked) {
    console.log("✅ Scripts already unblocked this session");
    window.unblockedScripts = { unblocked: true };
    window.yett.unblock();
    window.yettLoaded = true;
  } else {
    userIntentEvents.forEach(event =>
      window.addEventListener(event, unblockAllScripts, {
        once: true,
        passive: true,
        capture: true
      })
    );

    setTimeout(() => {
      if (!window.unblockedScripts?.unblocked) {
        console.log("⏰ Unblocking scripts via timeout fallback");
        unblockAllScripts();
        window.yettLoaded = true;
      }
    }, 300);
  }
} catch (e) {
  console.error("Error during script unblocking logic", e);
} */

/* console.log("🔥 blockscripts.js loaded");

// Espera a que Yett esté disponible antes de seguir
function whenYettReady(cb, attempts = 0) {
  if (window.yett && typeof window.yett.unblock === "function") {
    console.log("✅ Yett detected, initializing delayed logic...");
    cb();
  } else if (attempts < 50) {
    setTimeout(() => whenYettReady(cb, attempts + 1), 100);
  } else {
    console.warn("⚠️ Yett not found after waiting.");
  }
}

whenYettReady(() => {
  console.log("🧩 Setting up delayed releases...");
  setTimeout(() => {
    console.log("🕓 Releasing All scripts...");
    window.yett.unblock();
    window.yettLoaded = true;
  }, 2000);

  // --- Delayed releases ---
   setTimeout(() => {
    console.log("🕓 Releasing non-critical scripts (global delay)");
    window.yett.unblock(/upsell|vwo|posthog|searchanise|optmstr|visualwebsiteoptimizer/);
    window.yett.unblock();
  }, 3000);
}); */

(function () {
  // Bandera GLOBAL (sobrevive si el archivo se ejecuta 2+ veces)
  if (window.__SCRIPTS_UNBLOCKED__) {
    console.log('✅ Scripts already unblocked (global flag)');
    return;
  }

  // Eventos de intención (defínelos una sola vez en este scope)
  var userIntentEvents = ['mousemove', 'mousedown', 'scroll', 'keydown', 'touchstart'];

  function release() {
    // Idempotencia: si ya liberaste, sal
    if (window.__SCRIPTS_UNBLOCKED__) return;

    window.__SCRIPTS_UNBLOCKED__ = true; // <-- bandera global
    try { sessionStorage.setItem('scripts-unblocked', '1'); } catch(e){}

    if (window.yett && typeof window.yett.unblock === 'function') {
      console.log('▶️ Unblocking all via Yett');
      try { window.yett.unblock(); } catch(e) { console.warn('Yett unblock failed', e); }
    }

    // Limpia listeners (por si esta instancia los registró)
    userIntentEvents.forEach(function (evt) {
      window.removeEventListener(evt, onIntent, true);
    });
  }

  function onIntent() { release(); }

  // Si ya liberaste en esta sesión, libéralo inmediato y sal
  try {
    if (sessionStorage.getItem('scripts-unblocked') === '1') {
      console.log('✅ Scripts already unblocked this session');
      return release();
    }
  } catch(e){}

  // Registra triggers UNA vez por instancia (idempotente por la bandera global)
  userIntentEvents.forEach(function (evt) {
    window.addEventListener(evt, onIntent, { once: true, passive: true, capture: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(release, { timeout: 800 });
  }
  setTimeout(release, 800);
})();
